<template>
    <div class="recurring-commissionplan-summary">
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
                <span class='avenir-heavy'>Commissieplannen</span>
            </span>
            <dean-section-title-item
                :icon='plusIcon'
                :content="true"
                @click.native="sectionRoute('standingData.recurringCommissionPlan.add')"
            >
              toevoegen
            </dean-section-title-item>
          </dean-section-title>
          <dean-table
              :data='commissionPlans'
              :columns="columns"
              :hover="true"
              @column-click='columnClick'
              @cell-click="cellClick">
          </dean-table>
          <dean-pagination
              :current-page='metaData.pageNumber'
              :total-items='metaData.totalResults'
              :items-per-page='metaData.itemsPerPage'
              :select-items-per-page='selectItemsPerPage'
              :visible-pages='metaData.visiblePages'
              @page-changed='paginationChanged'
              @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
  import { Component } from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';

  import {
    // ICONS
    plusIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      plusIcon,
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
    },
  })
  export default class List extends mixins(deanTableMixin) {
    // DATA
    public commissionPlans: any = [];
    public commissionPlanGroups: any = [];
    public plusIcon: object = plusIcon;
    public columns: any = {
      name: {
        content: 'Naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
    };

    // COMPUTED
    get metaData() {
      return this.pageMeta;
    }

    get sideMenu(): object {
      return {
        title: {
          text: 'Commissieplannen',
          mobile: {
            close: {
              text: 'Close',
            },
          },
        },
        filters: {
          title: 'commissieplan groepen',
          items: this.commissionPlanGroups.concat(
            [{
              name: 'standingData.groups.add',
              title: 'toevoegen',
              icon: plusIcon,
            }],
          ),
        },
      };
    }

    public tableName(): string {
      return 'settings-rcps';
    }

    public cellClick(target: any) {
      if (target.row.startDate && target.row.endDate) {
        this.$router.push({
          name: 'standingData.recurringCommissionPlans.matrix.filter',
          params: {
            planId: target.row.id,
            startDate: target.row.startDate,
            endDate: target.row.endDate,
          },
        });
      } else {
         this.$router.push({
          name: 'standingData.recurringCommissionPlans.matrix',
          params: {
            planId: target.row.id,
          },
        });
      }
    }


    public loadList(data: any): void {
      this.$store.dispatch('setLoadOverlay', true);

      this.$store.dispatch('requestRecurringCommissionPlans', data)
        .then(
          (response: any) => {
            this.commissionPlans = response.data.data;

            return this.$store.dispatch('requestGroups', {type: 'service'});
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        )
        .then(
          (groupResponse: any) => {
            this.commissionPlanGroups = groupResponse.data.data.map((group: any) => {
              return {
                title: group.name,
                name: 'standingData.groups.edit',
                params: {
                  id: group.id,
                },
              };
            });
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        )
        .finally(() => {
          this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
          this.$store.dispatch('setLoadOverlay', false);
      });
    }


    public created() {
      this.setDefaultSort('name');
      this.loadList(this.pageMeta);
    }
  }
</script>

<style lang="scss" scoped>

</style>
